const cases = [
  {
    company: "Firma ogrodzeń — Kraków",
    icon: "ri-community-line",
    accent: "#059669",
    bg: "#ECFDF5",
    metric: "8",
    metricLabel: "zapytań / miesiąc",
    before: "Brak strony, tylko wizytówka Google",
    after: "Strona z galerią realizacji i formularzem",
    highlights: [
      "Lokalne SEO na frazę ogrodzenia Kraków",
      "Galeria realizacji z podpisami",
      "Formularz + przycisk Zadzwoń",
    ],
    chartBars: [1, 0, 2, 1, 3, 4, 5, 6, 7, 8],
    timeLabel: "6 tygodni po wdrożeniu",
  },
  {
    company: "Carporty — Wrocław",
    icon: "ri-car-line",
    accent: "#D97706",
    bg: "#FFFBEB",
    metric: "2–3",
    metricLabel: "leady / tydzień",
    before: "Strona wizytówka z 2010 roku",
    after: "Nowoczesny landing z konfiguratorem zapytań",
    highlights: [
      "Nowy landing pod kampanię Google Ads",
      "Formularz zapytania o wycenę",
      "Szybki mobile — 3s załadowania",
    ],
    chartBars: [1, 1, 2, 2, 3, 3, 4, 4, 5, 5],
    timeLabel: "po miesiącu",
  },
  {
    company: "Elektryk — Warszawa",
    icon: "ri-flashlight-line",
    accent: "#7C3AED",
    bg: "#F5F3FF",
    metric: "15+",
    metricLabel: "zapytań / miesiąc",
    before: "Strona bez CTA, niewidoczna w Google",
    after: "Strona z lokalnymi podstronami dzielnic",
    highlights: [
      "Podstrony na dzielnice Warszawy",
      "Przycisk Zadzwoń teraz zawsze widoczny",
      "Opinie Google na stronie",
    ],
    chartBars: [0, 1, 2, 3, 5, 7, 9, 11, 13, 15],
    timeLabel: "8 tygodni po wdrożeniu",
  },
];

const CaseStudySection = () => {
  return (
    <section className="py-20 lg:py-28 bg-[#F8FAFF]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="inline-block text-[#1D4ED8] text-sm font-semibold tracking-wide uppercase mb-4">
            Przykłady
          </span>
          <h2 className="text-3xl lg:text-4xl font-extrabold text-[#0F172A] mb-5 leading-tight">
            Strony, które przynoszą klientów
          </h2>
          <p className="text-[#64748B] text-lg leading-relaxed">
            Oto jak wygląda różnica w liczbie zapytań przed i po wdrożeniu strony zaprojektowanej pod pozyskiwanie klientów.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {cases.map((c) => (
            <div key={c.company} className="bg-white rounded-2xl border border-gray-100 overflow-hidden flex flex-col">
              {/* Header */}
              <div className="p-6 pb-4">
                <div className="flex items-center gap-3 mb-5">
                  <div
                    className="w-11 h-11 rounded-xl flex items-center justify-center"
                    style={{ backgroundColor: c.bg }}
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${c.icon} text-lg`} style={{ color: c.accent }}></i>
                    </div>
                  </div>
                  <p className="font-bold text-[#0F172A] text-sm">{c.company}</p>
                </div>

                {/* Metric */}
                <div className="text-center py-4 rounded-xl mb-4" style={{ backgroundColor: c.bg }}>
                  <p className="text-4xl font-extrabold" style={{ color: c.accent }}>{c.metric}</p>
                  <p className="text-xs font-semibold mt-1" style={{ color: c.accent }}>{c.metricLabel}</p>
                  <p className="text-xs text-[#94A3B8] mt-0.5">{c.timeLabel}</p>
                </div>

                {/* Chart */}
                <div className="flex items-end gap-1 h-10 mb-4">
                  {c.chartBars.map((v, i) => (
                    <div
                      key={i}
                      className="flex-1 rounded-sm transition-all"
                      style={{
                        height: v === 0 ? "4px" : `${(v / Math.max(...c.chartBars)) * 100}%`,
                        backgroundColor: i >= 6 ? c.accent : `${c.accent}30`,
                      }}
                    />
                  ))}
                </div>
              </div>

              {/* Before/After */}
              <div className="px-6 pb-4 flex flex-col gap-2">
                <div className="flex items-start gap-2 text-sm text-[#64748B]">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-close-circle-line text-red-400"></i>
                  </div>
                  <span><strong className="text-[#0F172A]">Przed:</strong> {c.before}</span>
                </div>
                <div className="flex items-start gap-2 text-sm text-[#64748B]">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-line text-green-500"></i>
                  </div>
                  <span><strong className="text-[#0F172A]">Po:</strong> {c.after}</span>
                </div>
              </div>

              {/* Highlights */}
              <div className="px-6 pb-6 mt-auto">
                <div className="border-t border-gray-50 pt-4 flex flex-col gap-1.5">
                  {c.highlights.map((h) => (
                    <div key={h} className="flex items-center gap-2 text-xs text-[#64748B]">
                      <div className="w-3 h-3 flex items-center justify-center flex-shrink-0">
                        <i className="ri-arrow-right-s-line" style={{ color: c.accent }}></i>
                      </div>
                      {h}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-[#94A3B8] text-xs mt-8">
          * Dane przykładowe ilustrujące możliwe efekty po wdrożeniu strony zoptymalizowanej pod pozyskiwanie klientów.
        </p>
      </div>
    </section>
  );
};

export default CaseStudySection;
